var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 15,
    viewBox: "0 0 12 15",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20788 4.95522H9.91644C10.6987 4.95522 11.3329 5.5894 11.3329 6.37166V13.4552C11.3329 14.2375 10.6987 14.8717 9.91644 14.8717H1.41644C0.634168 14.8717 0 14.2375 0 13.4552V6.37166C0 5.58939 0.634185 4.95522 1.41644 4.95522H2.125C2.51614 4.95522 2.8329 5.27264 2.8329 5.66378C2.8329 6.05492 2.51614 6.37168 2.125 6.37168H1.41644V13.4552H9.91644V6.37168H9.20788C8.81674 6.37168 8.49998 6.05492 8.49998 5.66378C8.49998 5.27264 8.81674 4.95522 9.20788 4.95522ZM6.375 2.41848V8.49666C6.375 8.8878 6.05758 9.20522 5.66644 9.20522C5.2753 9.20522 4.95788 8.8878 4.95788 8.49666V2.41848L4.16366 3.2127C3.88741 3.48895 3.43851 3.48895 3.16226 3.2127C2.88534 2.93579 2.88534 2.48755 3.16226 2.21064L5.16571 0.207188C5.44196 -0.0690625 5.89086 -0.0690625 6.16711 0.207188L8.17056 2.21064C8.44747 2.48755 8.44747 2.93579 8.17056 3.2127C7.89431 3.48895 7.44541 3.48895 7.16916 3.2127L6.375 2.41848Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.d6acd4f6960fd806a319a85dbd91c7e8.svg";
export { ForwardRef as ReactComponent };